import { observer } from "mobx-react-lite";
import { ContextProps } from "@menu/core/types";
import { getAnalyticTags } from "@menu/core/lib";
import useMenuActions from "@menu/components/use-menu-actions";

const SiteSwitcher = observer((props: ContextProps) => {
    const { context } = props;

    const { showChannels } = useMenuActions(context);

    const displaySites = context.displayChannelMenu;
    const icon = displaySites ? "icon-close" : "icon-site-switcher";

    const analyticTags = () => {
        const item = displaySites ? "open" : "close";
        const name = `site_switcher_${item}`;
        const text = displaySites ? "app-selection" : "x-icon";

        return getAnalyticTags({
            component_name: name,
            nav_item: item,
            nav_text: text,
            target_page_url: context.mainSiteUrl
        });
    }

    return (<i className={icon}
        {...analyticTags()}
        onClick={() => showChannels(!displaySites)} />);
});

export default SiteSwitcher;